module.exports = __webpack_public_path__ + "img/3331e77.png";